<template>
    <div class="card-instrucoes-carregamento-pedido-andamento">
        <g-card :temCabecalho="false" :expansivel="false">
            <div class="header-detalhes-secundario">
                <div class="header-detalhes-secundario-titulo">
                    <g-button
                    class="buscar-button-header"
                    largura="35px"
                    icone="icone_voltar.svg"
                    negritoTexto
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    altura="30px"
                    :sombreado="false"
                    @click="voltar()"
                    />

                <div class="titulo-detalhes-cabecalho"> Instruções de Carregamento </div>
                </div>
                <div class="header-icons" v-tooltip="'Abre uma janela para a impressão dos detalhes do cliente!'">
                    <g-button
                    class="botoes"
                    @click="imprimir()"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    >
                    <i class="pi pi-print"></i>
                    </g-button>
                </div>
            </div>

            <div class="conteudo-card-instrucoes-carregamento-pedido-andamento espacamento-detalhes">
                <div class="titulo-grupo-detalhes "> Dados Gerais </div>
                <div class="grupo-dados-instrucoes-carregamento topico">

                    <div class="instrucoes-carregamento-cliente">
                        <div class="titulo-conteudo-detalhes"> Pedido / Parcela </div>
                        <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoPedido}} / {{ this.novoInstrucoesCarregamento.NumeroParcela }}</div>
                    </div>

                    <div class="instrucoes-carregamento-unidade">
                        <div class="titulo-conteudo-detalhes"> Orçamento </div>
                        <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoOrcamento}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-produto">
                        <div class="titulo-conteudo-detalhes"> Produto </div>
                        <div class="label-conteudo">{{ this.detalhesDoPedidoFluxo.CodigoProduto }} - {{ this.detalhesDoPedidoFluxo.NomeProduto }} </div>
                    </div>

                    <div class="instrucoes-carregamento-cv">
                        <div class="titulo-conteudo-detalhes"> CV </div>
                        <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CurvaClienteTexto}} </div>
                    </div>

                    <div class="instrucoes-carregamento-representante">
                        <div class="titulo-conteudo-detalhes"> Representante </div>
                        <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.NomeRepresentante}} </div>
                    </div>

                    <div class="instrucoes-carregamento-unidade">
                        <div class="titulo-conteudo-detalhes"> Unidade </div>
                        <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.NomeEmpresa}} </div>
                    </div>

                    <div class="instrucoes-carregamento-cliente/CNPJ">
                        <div class="titulo-conteudo-detalhes"> Cliente / CNPJ </div>
                        <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoCliente}} - {{this.detalhesDoPedidoFluxo.NomeFantasia}} / {{this.detalhesDoPedidoFluxo.CnpjFormatado }} </div>
                    </div>

                    <div class="instrucoes-carregamento-tipo">
                        <div class="titulo-conteudo-detalhes"> Tipo </div>
                        <div class="label-conteudo"> {{this.detalhesDoPedidoFluxo.TipoPedidoTexto}} </div>
                    </div>
                </div>
            </div>

                <div class="conteudo-card-instrucoes-carregamento-pedido-andamento">
                <div class="titulo-grupo-detalhes "> Dados sobre o Processo</div>
                <div class="grupo-dados-instrucoes-carregamento topico">

                    <div class="produto-instrucoes-carregamento-data-entrega">
                        <div class="titulo-conteudo-detalhes"> Data Entrega </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.DataEntregaFormatada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-data-carreg">
                        <div class="titulo-conteudo-detalhes"> Data Carreg. </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.DataCarregamentoFormatada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-data-base">
                        <div class="titulo-conteudo-detalhes"> Data Base </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.DataBasePedidoParcelaFormatada || 'Não Possui'}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-oc">
                        <div class="titulo-conteudo-detalhes"> Ordem de Compra </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.NumeroOrdemDeCompra || 'Não Possui'}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-liberado">
                        <div class="titulo-conteudo-detalhes"> Liberado para produzir </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.LiberadoParaProduzir == false ? 'Não' : 'Sim'}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtde">
                        <div class="titulo-conteudo-detalhes"> Qtde </div>
                        <div class="label-conteudo"> {{formataDecimal(this.novoInstrucoesCarregamento.QuantidadePedidoParcela)}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtd-produzida">
                        <div class="titulo-conteudo-detalhes"> Qtde Produzida </div>
                        <div class="label-conteudo"> {{formataDecimal(this.novoInstrucoesCarregamento.QuantidadeProduzida)}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtd-expedida">
                        <div class="titulo-conteudo-detalhes"> Qtde Expedida </div>
                        <div class="label-conteudo"> {{formataDecimal(this.novoInstrucoesCarregamento.QuantidadeExpandida)}} </div>
                    </div>
                    
                    <div class="produto-instrucoes-carregamento-componente">
                        <div class="titulo-conteudo-detalhes"> Componente </div>
                        <div class="label-conteudo" v-for="(componente, index) in CompFaseArray" :key="index"> {{componente.componenteTipoEnumTexto}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-fase-producao">
                        <div class="titulo-conteudo-detalhes"> Fase de Produção </div>
                        <div class="label-conteudo" v-for="(componente, index) in CompFaseArray" :key="index"> {{componente.descricaoFaseProduto || 'Não Possui'}} </div>
                    </div>
            </div>
        </div>


            <div class="conteudo-card-instrucoes-carregamento-pedido-andamento" v-if="this.novoInstrucoesCarregamento.NomeUsuario">
                <div class="titulo-grupo-detalhes "> Instruções </div>
                <div class="grupo-dados-instrucoes-carregamento topico">

                    <div class="produto-instrucoes-carregamento-liberacao-carregamento">
                        <div class="titulo-conteudo-detalhes"> Liberação de Carregamento </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.QuantidadeLiberada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-data-liberação">
                        <div class="titulo-conteudo-detalhes"> Data da Liberação </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.DataLiberacaoCarregamentoFormatada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-data-entrega">
                        <div class="titulo-conteudo-detalhes"> Data Entrega </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.DataCarregamentoFormatada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtde-carregada">
                        <div class="titulo-conteudo-detalhes"> Qtde Carregada </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.QuantidadeCarregada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-qtde-liberada">
                        <div class="titulo-conteudo-detalhes"> Qtde Liberada </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.QuantidadeLiberada}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-oc">
                        <div class="titulo-conteudo-detalhes"> Ordem de Compra </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.NumeroOrdemDeCompra}} </div>
                    </div>

                    <div class="produto-instrucoes-cliente-aceita">
                        <div class="titulo-conteudo-detalhes"> Cliente Aceita </div>
                        <div class="label-conteudo"> Min: {{this.novoInstrucoesCarregamento.NumeroMinimo}} / Max: {{this.novoInstrucoesCarregamento.NumeroMaximo}}</div>
                    </div>

                    <div class="produto-instrucoes-carregamento-usuario">
                        <div class="titulo-conteudo-detalhes"> Usuário Responsável pela Liberação </div>
                        <div class="label-conteudo"> {{this.novoInstrucoesCarregamento.NomeUsuario}} </div>
                    </div>
                </div>
            </div>
       

            <div class="conteudo-card-instrucoes-carregamento-pedido-andamento">
                <div class="titulo-grupo-detalhes "> Clientes para Faturamento (Desdobramento) </div>
                <div class="grupo-dados-instrucoes-carregamento topico">

                    <div class="produto-instrucoes-carregamento-codigo">
                        <div class="titulo-conteudo-detalhes"> Código </div>
                        <div class="label-conteudo"> {{this.pedidoDesdobramento.ClienteCodigo}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-nome">
                        <div class="titulo-conteudo-detalhes"> Nome </div>
                        <div class="label-conteudo"> {{this.pedidoDesdobramento.ClienteNome}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-ordem-compra">
                        <div class="titulo-conteudo-detalhes"> Ordem de Compra </div>
                        <div class="label-conteudo"> {{this.pedidoDesdobramento.NumeroOrdemCompra}} </div>
                    </div>

                    <div class="produto-instrucoes-carregamento-obs">
                        <div class="titulo-conteudo-detalhes"> Observações </div>
                        <div class="label-conteudo"> 	{{this.pedidoDesdobramento.QuantidadeFaturar}} </div>
                    </div>
                </div>
            </div>
        </g-card>
    </div>
    <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
            <div class="container-logo">
                <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
            </div>
            <div class="render" v-if="renderiza">
                <InstrucoesCarregamentoPedidoEmAndamentoPDF :tituloDetalhes="false" v-on:termino="gerarPdf" :pedidoSelecionado="PedidoId"></InstrucoesCarregamentoPedidoEmAndamentoPDF>
            </div>
    </g-pdf>
</template>

<script>
import InstrucoesCarregamentoPedidoEmAndamento from './InstrucoesCarregamentoPedidoEmAndamento.js'
export default InstrucoesCarregamentoPedidoEmAndamento
</script>

<style scoped>
.container-logo{
  padding: 30px 30px 10px 53px;
}

.card-titulo-instrucoes-carregamento {
    color: #4f2c19;
    font-weight: bold;
    font-size: 1.3rem;
}

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.grupo {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-top: 30px;
  display: flex;
}

.titulo {
  color: #3e3e3e;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
  margin-top: 15px;
}

.conteudo {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}


@media(min-width:310px) {
    .grupo-dados-instrucoes-carregamento{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
.header-instrucoes-carregamento-pedido-andamento {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.grupo {font-size: 18px;}
}


@media(min-width:368px) {
.header-instrucoes-carregamento-pedido-andamento {grid-template-columns: 25% repeat(2, auto);}
}


@media(min-width:600px) {
    .grupo-dados-instrucoes-carregamento{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
.header-instrucoes-carregamento-pedido-andamento {padding: 20px 0 10px;}
}


@media(min-width:801px) {
    .grupo-dados-instrucoes-carregamento{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
.conteudo-card-instrucoes-carregamento-pedido-andamento {padding: 0 30px;}
}


@media(min-width:1025px) {
.conteudo-card-instrucoes-carregamento-pedido-andamento {padding: 0 50px;}
.grupo {font-size: 19px;}
}


@media(min-width:1285px) {
    .grupo-dados-instrucoes-carregamento{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
}

@media(min-width:1500px) {}
</style>